import { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import apiClient from '../api/client'

function LoginPage(): JSX.Element {
  const navigate = useNavigate()
  const location = useLocation() as {
    state?: { registered?: boolean; registeredPending?: boolean; resetDone?: boolean }
  }
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await apiClient.post('/auth/login', { email, password })
      navigate('/dashboard')
    } catch (err: unknown) {
      let msg = 'Login failed'
      const maybeAxios = err as { response?: { data?: { detail?: string } }; message?: string }
      if (maybeAxios?.response?.data?.detail) msg = maybeAxios.response.data.detail
      else if (maybeAxios?.message) msg = maybeAxios.message
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">BibPipeline</h1>
        <p className="login-subtitle">Sign in to your account</p>
        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label">
            Email
            <input
              type="email"
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="login-label">
            Password
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {location.state?.registeredPending && (
            <p style={{ color: '#0a0', fontSize: 14, marginBottom: 8 }}>Account created — waiting for admin approval before you can sign in.</p>
          )}
          {location.state?.registered && (
            <p style={{ color: '#0a0', fontSize: 14, marginBottom: 8 }}>Account created — please sign in.</p>
          )}
          {location.state?.resetDone && (
            <p style={{ color: '#0a0', fontSize: 14, marginBottom: 8 }}>Password updated — please sign in.</p>
          )}
          {error && <p style={{ color: '#c00', fontSize: 14 }}>{error}</p>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        <p style={{ marginTop: 12, fontSize: 14, textAlign: 'center' }}>
          <Link to="/forgot-password">Forgot password?</Link>
        </p>
        <p style={{ marginTop: 16, fontSize: 14, textAlign: 'center' }}>
          Don&apos;t have an account? <Link to="/register">Create one</Link>
        </p>
      </div>
    </div>
  )
}

export default LoginPage
